$(function(){
    var $creditButton = $('[js-card-credit-buying]');
    $('body').on('click', '[js-card-credit-buying]', function(e){
        var $btn = $(this);
        var options = {
            ttCode: $btn.data('ttcode'),
            ttName: $btn.data('ttname'),
            order: [
                {
                    title: 'Фитнес',
                    category: 268,
                    model: $btn.data('model'),
                    price: $btn.data('price')
                }
            ]
        };

        window.PBSDK.posCredit.mount('#pos-credit-container-' + $btn.data('target') , options);

        var $posContainer = $('#pos-credit-container-' + $btn.data('target'));
        $posContainer.find('.pb-sdk-pos-credit__order').remove();
        $posContainer.addClass('is-open');
        var $posContainerOverlay = $posContainer.closest('.pos-credit-container-overlay');
        $posContainerOverlay.fadeIn(250);
        $posContainerOverlay.addClass('is-open');

        $posContainerOverlay.css({
            'display': 'flex'
        });

        $('body').css({
           'overflow': 'hidden'
        });
        $posContainer.fadeIn(400);

        $posContainer.append('<div class="closer" js-pochta-modal-close></div>');
        var $closer = $posContainer.find('.closer');
        $closer.attr('js-pochta-modal-close');
    });

    $('body').on('click', '[js-pochta-modal-close]', function(e){
        if (e.target.hasAttribute('js-pochta-modal-close')) {
            var $overlay = $('[js-pochta-modal-close].is-open');
            var $posContainer = $overlay.find('.pos-credit-container');

            console.log($overlay);
            console.log($posContainer);
            $('body').css({
                'overflow': 'visible'
            });
            $overlay.removeClass('is-open');
            $posContainer.removeClass('is-open');
            window.PBSDK.posCredit.unmount('#' + $posContainer.attr('id'));
            $posContainer.fadeOut(300);
            $overlay.fadeOut(400);
            return false;
        }
    });
});